import React, { useState } from 'react';
import CreateDrawer from '../setUpChannel';
import { Icon, Message, Switch, Popover } from '@b-design/fusion';
import $i18n from '@/i18n';
import Confirm from '@/components/Confirm';
import './index.less';
import Requests from '@/services/request';
import NameIcon from '@/components/NameIcon';
import PaginationComponent from '@/components/PaginationComponent';
import { getQueryStringArgs } from '@/utils/url-parse';
import Button from '@/components/Button';

export default function App({ dataSource, callback, paginationValue, setPaginationValue }) {
  const [drawerVisible, setDrawerVisible] = useState(false);
  // const [dataSource, setDataSource] = useState<any>({ list: [], total: 0 });
  const [editValue, setEditValue] = useState<any>(null);

  const { spaceId } = getQueryStringArgs();
  //渠道删除
  const channelDelete = async (value) => {
    const data = await Requests.post('/rest/intercnn/publishChannel/delete', {
      spaceId,
      innerCode: value?.innerCode,
    });
    if (data) {
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
          dm: '删除成功',
        }),
      });
      //判断是否为最后一页之后一条数据
      const num = Math.ceil(dataSource.total / 12);
      if (num == paginationValue.currentPage && dataSource.total % 12 == 1 && num != 1) {
        setPaginationValue({ ...paginationValue, currentPage: paginationValue.currentPage - 1 });
      } else {
        callback({ spaceId, ...paginationValue });
      }
    }
  };
  //switch
  const channelSwitch = async (value) => {
    //关闭
    if (value?.status == 'ONLINE') {
      const data = await Requests.post('/rest/intercnn/publishChannel/offline', {
        spaceId,
        innerCode: value?.innerCode,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.channelSetting.appList.message.success',
            dm: '操作成功',
          }),
        });
        // setPaginationValue({
        //   currentPage: 1,
        //   pageSize: 12,
        // });

        callback({ spaceId, ...paginationValue });
      }
    } else {
      const data = await Requests.post('/rest/intercnn/publishChannel/online', {
        spaceId,
        innerCode: value?.innerCode,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.channelSetting.appList.message.success',
            dm: '操作成功',
          }),
        });
        // setPaginationValue({
        //   currentPage: 1,
        //   pageSize: 12,
        // });

        callback({ spaceId, ...paginationValue });
      }
    }
  };

  const onRefresh = () => {
    callback({ spaceId, ...paginationValue });
  };

  return (
    <div className="list-content applist-content">
      <Button
        style={{ borderRadius: '4px' }}
        type="primary"
        onClick={() => {
          setDrawerVisible(true);
          setEditValue(null);
        }}
      >
        {$i18n.get({
          id: 'aopf.pages.channel.creatApp',
          dm: '创建应用',
        })}
      </Button>

      <div className="channelSet-applist-defines">
        {$i18n.get({
          id: 'aopf.pages.channel.AppSettings.defines',
          dm: '应用程序定义了你的迷你小程序的上架、运行和设置',
        })}
      </div>
      <div className="channelSet-applist-container">
        {dataSource?.list?.map((item, index) => (
          <div className="channelSet-applist-item" key={index}>
            <div className="channelSet-applist-itemImg">
              {item.iconPublicUrl ? (
                <img className="channelSet-applist-img" src={item?.iconPublicUrl} alt="" />
              ) : (
                <NameIcon
                  name={item?.name}
                  styles={{
                    width: 64,
                    height: 64,
                    margin: '0 auto',
                    fontSize: '36px',
                    fontWeight: '700',
                    borderRadius: '6px',
                    lineHeight: '64px',
                    textAlign: 'center',
                    display: 'block',
                    color: 'rgb(240, 254, 255)',
                    backgroundColor: 'rgb(45, 199, 205)',
                    position: 'relative',
                  }}
                />
              )}
            </div>
            <div className="channelSet-applist-icon">
              <Confirm
                trigger={
                  item?.status != 'ONLINE' && (
                    <Icon style={{ cursor: 'pointer' }} type="trash-can--outline" size="small" />
                  )
                }
                dialogTitle={$i18n.get({
                  id: 'aopf.pages.channel.channelList.message.deleteTitle',
                  dm: '删除',
                })}
                dialogContent={$i18n.get({
                  id: 'aopf.pages.channel.channelList.message.deleteContent',
                  dm: '确定删除该内容?',
                })}
                onClick={channelDelete.bind(null, item)}
              />
              <Icon
                style={{ marginLeft: '14px', cursor: 'pointer' }}
                type="edit--outline"
                size="small"
                onClick={() => {
                  setDrawerVisible(true);
                  setEditValue(item);
                }}
              />
              <Confirm
                trigger={
                  <Switch
                    style={{ marginLeft: '14px' }}
                    data-size="xs"
                    defaultChecked={item?.status == 'ONLINE'}
                    data-type={'circle'}
                    checked={item?.status == 'ONLINE'}
                  />
                }
                dialogTitle={
                  item?.status == 'ONLINE'
                    ? $i18n.get({
                      id: 'aopf.pages.channelSetting.appList.close',
                      dm: '下线',
                    })
                    : $i18n.get({
                      id: 'aopf.pages.channelSetting.appList.open',
                      dm: '上线',
                    })
                }
                dialogContent={
                  item?.status == 'ONLINE'
                    ? $i18n.get({
                      id: 'aopf.pages.channelSetting.appList.closeDes',
                      dm: '确认下线该应用吗?',
                    })
                    : $i18n.get({
                      id: 'aopf.pages.channelSetting.appList.openDes',
                      dm: '确认上线该应用吗?',
                    })
                }
                onClick={channelSwitch.bind(null, item)}
              />
            </div>
            <Popover
              align="t"
              v2
              closable={false}
              trigger={<div className="channelSet-applist-appTitle">{item?.name}</div>}
            >
              <div>{item?.name}</div>
            </Popover>
            <div className="channelSet-applist-appCode">{item?.innerCode}</div>
          </div>
        ))}
      </div>
      <div className="pagenation-container">
        <PaginationComponent
          total={dataSource?.total}
          current={paginationValue?.currentPage}
          pageSize={paginationValue?.pageSize}
          pageSizeSelector={false}
          onPageChange={(current, pageSize) => {
            setPaginationValue({
              currentPage: current,
              pageSize,
            });
          }}
        />
      </div>
      {
        <CreateDrawer
          drawerVisible={drawerVisible}
          setDrawerVisible={setDrawerVisible}
          editValue={editValue}
          setEditValue={setEditValue}
          setPaginationValue={setPaginationValue}
          onRefresh={onRefresh}
        />
      }
    </div>
  );
}
